import {
  PageBlueprint,
  createFrontendPlugin,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import {
  compatWrapper,
  convertLegacyRouteRef,
  convertLegacyRouteRefs,
} from '@backstage/core-compat-api';
import InsightsIcon from '@mui/icons-material/Insights';

import { rootRouteRef } from './routes';

// `title` and `icon` are what put this in the sidebar. PageBlueprint emits
// core.title/core.icon only when they are supplied, and the app's Sidebar renders
// nav.rest() over the nav items that exist - it does not synthesise one from a
// registered route. Without them the page is reachable at its path and invisible
// everywhere else.
const dashboardPage = PageBlueprint.make({
  params: {
    path: '/databricks',
    // Named after the vendor, not the content. There is a sibling Datadog page
    // with its own embedding model, and the sidebar sorts by title - "Dashboards"
    // next to "Datadog" read as two unrelated things rather than a pair.
    title: 'Databricks',
    icon: <InsightsIcon />,
    routeRef: convertLegacyRouteRef(rootRouteRef),
    async loader() {
      const { DashboardPage } = await import('./components');
      return compatWrapper(<DashboardPage />);
    },
  },
});

export const databricksDashboardPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'databricks-dashboard',
  extensions: [dashboardPage],
  routes: convertLegacyRouteRefs({
    root: rootRouteRef,
  }),
});
